import { useEffect } from "react";

/**
 * @typedef {import("./minMaxErrorMessageTypes").UseUpdateShowMessageProps} UseUpdateShowMessageProps
 */

/**
 *
 * @param {UseUpdateShowMessageProps} props
 * @returns {null}
 */
const useUpdateShowMessage = ({
    handleHideMessage,
    handleShowMessage,
    hasAttemptedSubmission,
    hasMinMaxValidationError,
    subtotal,
}) => {
    useEffect(() => {
        if (hasAttemptedSubmission) {
            if (hasMinMaxValidationError) {
                handleShowMessage();
            } else {
                handleHideMessage();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [subtotal]);

    return null;
};

export default useUpdateShowMessage;
